/**
 * @param {Object} product - product image
 * @param {boolean} hasSwatches - whether swatches are available
 * @param {boolean} lazyLoading - lazy load tile images
 * @returns {string} product image HTML
 */
export default (product, hasSwatches, lazyLoading) => `
    <div class="product-image" data-product-id="${product.ID}">
        <div class="js-product-image-placeholder">
        ${
            product.sliderImagesHTML
                ? product.sliderImagesHTML
                : `
                <img src="${product.image.url}" alt="" class="hover-tileimage" ${lazyLoading ? 'loading="lazy"' : ''}">`
        }
        </div>
        ${
            hasSwatches
                ? `
                <div class="color-swatch-hover hidden tile-swatch">
                    <img class="standard-tileimage" src="" alt="" title="" />
                </div>
                `
                : ''
        }
    </div>`;
